import React from 'react';

type Props = {
};

function SelectedContentPartition({ }: Props) {
	return (
		<></>
	);
}

export default SelectedContentPartition;